import { makeQuery } from 'shared/utilities';
import { IDocumentCategoryModel } from 'shared/models';

type ResponseType = {
    item: IDocumentCategoryModel;
};

export const documentCategoriesGetQuery = async function (id: number) {
    return await makeQuery<ResponseType>('/document-categories/get', { params: { id } });
}
